import React, {useContext} from "react";
import { Navigate, NavLink, useNavigate } from "react-router-dom";
import TokenContext from "../../utils/tokenContext";
import "./AdminNav.css";
import api from "../../utils/API"

const AdminNav = (props) => {
  const {logout, token} = useContext(TokenContext);
  const navigate = useNavigate();

  const logOutUser = () => {
      window.localStorage.clear()
      navigate('/');
  }
  return (
    <nav className="nav-extended">
      <div className="nav-wrapper">
        <NavLink to="/" className="brand-logo center blk">
          JTNails
        </NavLink>
      </div>
      <div className="nav-content ">
        <ul className="tabs tabs-transparent ">
          <li className="tab blk ">
            <NavLink to="/admin/menu" className="blk ">Services</NavLink>
          </li>
          <li className="tab blk">
            <NavLink to="/admin/menu/add" className="blk">Add Services</NavLink>
          </li>
          <li className="tab blk">
            <NavLink to="/admin/orders" className="blk">MANAGE QUEUE</NavLink>
          </li>
          {/* <li className="tab blk">
            <NavLink to="/queue" className="blk">Display QUEUE</NavLink>
          </li> */}
          <li className="tab">
            <NavLink to="/admin/create-user" className="blk">Add Employee</NavLink>
          </li>
          <li className="tab blk">
            <button className="btn submit-button" onClick={()=>logOutUser()}>LOGOUT</button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AdminNav;
